import PinchMeAPI from "../lib/PinchMeAPI";
import {
  fetchSampleTuesdayDatePending,
  fetchSampleTuesdayDateSuccess,
  fetchSampleTuesdayDateFail
} from "../dux/landing";

export default function fetchSampleTuesdayDate() {
  return dispatch => {
    dispatch(fetchSampleTuesdayDatePending());
    PinchMeAPI.getSampleTuesdayDate()
      .then(res => {
        if (res.error) {
          throw res.error;
        }
        dispatch(fetchSampleTuesdayDateSuccess(res.sample_tuesday_date));
        return res;
      })
      .catch(error => {
        dispatch(fetchSampleTuesdayDateFail(error));
      });
  };
}
